import { campaignLength } from "../constants/campaignLength";

export const getFormattedCampaignLength = length =>
  campaignLength.find(({ value }) => value === length).label;
